// Trainer Demo — shared constants, tokens & helpers
export const DEMO_TYPES = ['Online', 'Offline', 'Hybrid'];

// Trainer-side feedback (Demo Quality removed; Course Fit lives here too)
export const TRAINER_FB = {
  student_engagement: { label: 'Student Engagement', options: ['High', 'Medium', 'Low'], hint: 'How actively did the student participate?' },
  student_understanding: { label: 'Student Understanding', options: ['High', 'Medium', 'Low'], hint: 'Could they follow the concepts?' },
  trainer_interest: { label: 'Interest You Sensed', options: ['Positive', 'Neutral', 'Negative'], hint: 'Your read on the student\u2019s intent' },
  questions_raised: { label: 'Questions Raised', options: ['Yes', 'No'], hint: 'Did the student ask questions?' },
  course_fit: { label: 'Course Fit', options: ['Good', 'Partial', 'Poor'], hint: 'Is this the right course for them?' },
};

export const COUNSELLOR_FB = {
  student_response: { label: 'Student Response', options: ['Positive', 'Neutral', 'Negative'], hint: 'Post-demo conversation tone' },
  purchase_intent: { label: 'Purchase Intent', options: ['High', 'Medium', 'Low'], hint: 'How close are they to enrolling?' },
  budget_concern: { label: 'Budget Concern', options: ['Yes', 'No'], hint: 'Was price raised as a blocker?' },
  course_fit: { label: 'Course Fit', options: ['Good', 'Partial', 'Poor'], hint: 'Is this the right course for them?' },
};

export const NO_ADMISSION_REASONS = [
  'Price / Budget', 'Course Not Suitable', 'Timing Issue', 'Student Not Interested',
  'Trainer/Demo Experience', 'Comparing Other Options', 'Wants to Join Later',
  'Career/Requirement Changed', 'Other',
];

export const NOT_DONE_REASONS = [
  'Student did not turn up',
  'Student rescheduled',
  'Trainer unavailable',
  'Technical issue',
  'Student unreachable',
  'Duplicate entry',
  'Created by mistake',
  'Other',
];

const PILL = 'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold tracking-wide border';
export const STATUS_META = {
  pending_approval: { label: 'Pending Approval', cls: `${PILL} bg-violet-50 text-violet-700 border-violet-200/70` },
  approved: { label: 'Approved', cls: `${PILL} bg-emerald-50 text-emerald-700 border-emerald-200/70` },
  rejected: { label: 'Rejected', cls: `${PILL} bg-rose-50 text-rose-700 border-rose-200/70` },
  not_done: { label: 'Not Conducted', cls: `${PILL} bg-slate-100 text-slate-500 border-slate-200` },
  not_applicable: { label: 'Not Applicable', cls: `${PILL} bg-slate-100 text-slate-500 border-slate-200` },
};
export const OUTCOME_META = {
  admission: { label: 'Admission', cls: `${PILL} bg-emerald-50 text-emerald-700 border-emerald-200/70` },
  no_admission: { label: 'No Admission', cls: `${PILL} bg-rose-50 text-rose-700 border-rose-200/70` },
  follow_up: { label: 'Follow-up', cls: `${PILL} bg-sky-50 text-sky-700 border-sky-200/70` },
};
export const ALIGN_META = {
  aligned: { dot: '🟢', label: 'High Alignment', cls: 'text-emerald-700', badge: `${PILL} bg-emerald-50 text-emerald-800 border-emerald-200/70` },
  partial: { dot: '🟠', label: 'Partial Gap', cls: 'text-amber-700', badge: `${PILL} bg-amber-50 text-amber-800 border-amber-200/70` },
  contradictory: { dot: '🔴', label: 'Critical Mismatch', cls: 'text-rose-700', badge: `${PILL} bg-rose-50 text-rose-800 border-rose-200/70` },
};

export const isMgr = (role) => role === 'admin' || role === 'manager';
export const isAdmin = (role) => role === 'admin';
export const todayStr = () => new Date().toISOString().slice(0, 10);
export const demoBase = (role) => (role === 'trainer' ? '/trainer/demos' : '/training/trainer-demo');

const MON = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
export const fmtDate = (iso) => {
  if (!iso) return '—';
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  const mi = parseInt(m, 10) - 1;
  if (!y || mi < 0 || mi > 11) return iso;
  return `${d}-${MON[mi]}-${y}`;
};
export const fmtTime = (t) => {
  if (!t) return '—';
  const [hh, mm] = String(t).split(':');
  const h = parseInt(hh, 10);
  if (Number.isNaN(h)) return t;
  const ap = h >= 12 ? 'PM' : 'AM';
  return `${((h + 11) % 12) + 1}:${mm || '00'} ${ap}`;
};
